import Vue from 'vue'
import VueQuagga from 'vue-quaggajs'

Vue.use(VueQuagga)
